// extracted by mini-css-extract-plugin
export default {"register-tab":"RegisterTab_register-tab__Ck2Wt"};